import React from 'react';
import * as Flags from 'country-flag-icons/react/3x2';

// country-flag-icons keys on ISO-2 while countries.iso_code is ISO-3, so a
// market needs a bridge entry here to get a flag. Kept in one place because
// the admin console and the project cards all key off the same iso_code.
export const ALPHA3_TO_ALPHA2 = {
  BEL: 'BE', CAN: 'CA', DEU: 'DE', JPN: 'JP',
  MEX: 'MX', ESP: 'ES', CHE: 'CH', GBR: 'GB',
  USA: 'US', IND: 'IN', BRA: 'BR', FRA: 'FR', ITA: 'IT', AUS: 'AU', CHN: 'CN',
};

// An unmapped market, or a legacy project with no country, renders nothing
// rather than leaving a broken slot.
const CountryFlag = ({ iso3, name, className = '' }) => {
  const Flag = Flags[ALPHA3_TO_ALPHA2[iso3]];
  if (!Flag) return null;

  return (
    <span
      className={`ev-country-flag ${className}`.trim()}
      data-tooltip={name || iso3}
      role="img"
      aria-label={name || iso3}
    >
      <Flag />
    </span>
  );
};

export default CountryFlag;
